import { ModuleType } from "../../queryKeyFactory";

export const settingsKeyFactory = {
    readingFormatList : (search): [ModuleType, 'format-list', string] => ['mx', 'format-list', search],
    userUtilityServices: (): [ModuleType, "utility-services"] =>
  ["mx", "utility-services"],
    viewMeterReadingFormatDetail: (id: string): [ModuleType, "meter-reading-format-detail", string] =>
  ["mx", "meter-reading-format-detail", id],
  viewMeterReaders: (page: number, search?): [ModuleType, "meter-reader", number, string] => [
  "mx",
  "meter-reader",
  page,
  search
],
meterReadingStatusList: ( page, search): [ModuleType, "meter-reading-status", number, string] =>
  ["mx", "meter-reading-status", page, search],
meterReasonCodesList: (page, search): [ModuleType, "reason-code-list", number, string] => ['mx', "reason-code-list", page, search],
viewActiveMeterStatuses: (): [ModuleType, "active-reading-status"] =>
  ["mx", "active-reading-status"],
}